module.exports = {"information":"Information","mailService":"Mail for Service","google":"Google Integration","exchange":"Exchange Integration","noIntegration":"Your site doesn't set integration.","integrate":"Integration","changeConfig":"Change Config"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/integration/EN.json
// module id = 1334
// module chunks = 120